//
//  DocumentationLegacyPageBlockFrame.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
import { FrameOrigin } from "../../support/SDKFrameOrigin";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockFrame {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, blockBackgroundColor) {
        var _a, _b, _c, _d, _e;
        // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
        this.title =
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            model.title.length > 0 ? model.title : ((_a = model.origin.title) !== null && _a !== void 0 ? _a : null);
        // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
        this.description = model.description.length > 0 ? model.description : null;
        // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        this.previewUrl = model.origin.previewUrl;
        this.backgroundColor = (_c = (_b = model.backgroundColor) !== null && _b !== void 0 ? _b : blockBackgroundColor) !== null && _c !== void 0 ? _c : null;
        this.persistentId = (_e = (_d = model.persistentId) !== null && _d !== void 0 ? _d : model.persistentId) !== null && _e !== void 0 ? _e : null;
        this.origin = model.origin
            ? new FrameOrigin(model.origin, model.sourceId, model.sourceFrameId)
            : null;
    }
}
